import { Expose } from 'class-transformer';
import type BillingAccount from './BillingAccount';
import type BillingField from '../types/BillingField';

export default class BasketBillingMethod {
  @Expose() billingmethod: (string | null) = null;
  @Expose() amount: (number | null) = 0;
  @Expose() cardname: (string | null) = null;
  @Expose() cardnumber: (string | null) = null;
  @Expose() expiryyear: (number | null) = null;
  @Expose() expirymonth: (number | null) = null;
  @Expose() cvv: (string | null) = null;
  @Expose() streetaddress: (string | null) = null;
  @Expose() streetaddress2: (string | null) = null;
  @Expose() city: (string | null) = null;
  @Expose() state: (string | null) = null;
  @Expose() zip: (string | null) = null;
  @Expose() tipportion: (number | null) = 0;
  @Expose() country: (string | null) = null;
  @Expose() saveonfile: (string | null) = null;
  @Expose() isdefault: boolean = false;
  @Expose() billingaccountid: (string | null) = null;
  @Expose() billingschemeid: (string | null) = null;
  @Expose() billingfields: BillingField[] = [];
  @Expose() billingAccount: (BillingAccount | null) = null;

  constructor(
    billingmethod: string,
    amount: number,
    cardname: string,
    cardnumber: string,
    expiryyear: number,
    expirymonth: number,
    cvv: string,
    streetaddress: string,
    streetaddress2: string,
    city: string,
    state: string,
    zip: string,
    tipportion: number,
    country: string,
    saveonfile: string,
    isdefault: boolean,
    billingaccountid: string,
    billingschemeid: string,
    billingfields: BillingField[],
    billingAccount: BillingAccount) {
    this.billingmethod = billingmethod || null;
    this.amount = amount || 0.00;
    this.cardname = cardname || null;
    this.cardnumber = cardnumber || null;
    this.expiryyear = expiryyear || null;
    this.expirymonth = expirymonth || null;
    this.cvv = cvv || null;
    this.streetaddress = streetaddress || null;
    this.streetaddress2 = streetaddress2 || null;
    this.city = city || null;
    this.state = state || null;
    this.zip = zip || null;
    this.tipportion = tipportion || 0.00;
    this.country = country || null;
    this.saveonfile = saveonfile || null;
    this.isdefault = isdefault || false;
    this.billingaccountid = billingaccountid || null;
    this.billingschemeid = billingschemeid || null;
    this.billingfields = billingfields;
    this.billingAccount = billingAccount || null;
  }
}